<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useSessionStore } from '@/stores/session.ts';
import { useQRCode } from '@vueuse/integrations/useQRCode';
import { useClipboard, useCountdown } from '@vueuse/core';
import { toast } from '@pokerly/ui';
import { useFlags } from '@/composables/use-feature-flags.ts';
import { Flags } from '@pokerly/shared-common';
import { IconCopy, IconCheck } from '@tabler/icons-vue';
import { PButton, PPopover, PPopoverContent, PPopoverTrigger } from '@pokerly/ui';
import QrCodeIcon from '@/assets/icons/QrCodeIcon.vue';

const sessionStore = useSessionStore();
const { isSupported, copy } = useClipboard();
const route = useRoute();
const pok42Flag = useFlags(Flags.POK_42_QR_CODE);

const url = computed(() => `${import.meta.env.VITE_APP_ROOT}${route.fullPath}`);
const qrcode = useQRCode(url, { color: { light: '#ffffffff', dark: '#000000FF' } });
const { start, isActive } = useCountdown(2);

function onCopy() {
    copy(url.value);
    start();
    toast('Session link copied to clipboard', {
        duration: 2000,
    });
}
</script>

<template>
    <div class="flex items-center justify-center h-full gap-2">
        <div class="p-2 flex items-center">
            <span class="px-2 py-1.5 paragraph-sm text-foreground-muted"> Share this session:</span>
            <span class="px-3 py-1.5 font-bold paragraph-sm text-foreground-primary">{{ sessionStore.room }}</span>
            <PButton
                v-if="isSupported && !isActive"
                class="cursor-pointer"
                variant="ghost"
                size="icon-sm"
                @click="onCopy"
            >
                <IconCopy />
            </PButton>
            <div v-if="isActive" class="p-2">
                <IconCheck class="text-green-600 size-4" />
            </div>
        </div>
        <PPopover v-if="pok42Flag.enabled">
            <PPopoverTrigger>
                <QrCodeIcon class="size-5 cursor-pointer" />
            </PPopoverTrigger>
            <PPopoverContent><img :src="qrcode" alt="QR Code" /></PPopoverContent>
        </PPopover>
    </div>
</template>
